import { ApiResult } from "@/interfaces/api.interface";
import { UpdateMenteCommentModle } from "@/interfaces/menteComment.interface";
import request from "@/utils/request";
import { AxiosPromise } from "axios";

// 会社関連
export function getMenteComment(): AxiosPromise<ApiResult<any>> {
  return request({
    url: `mente-comment/get`,
    method: "get",
  });
}

export function updateMenteComment(
  data: UpdateMenteCommentModle
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `mente-comment/update`,
    method: "patch",
    data,
  });
}
